module.exports = __webpack_public_path__ + "img/logo.dd86dc66.png";